import { createService } from "services/serviceFactory";
import { PhytoviewEntry, PhytoViewEntryResponse, PhytoviewRequest } from "./response";
import { GetPhytoViewEntriesRequest } from "./request";
import { getAuthHeaders } from "modules/common";

const phytoviewService = createService("phytoview");

async function getPhytoViewEntries(
    data: GetPhytoViewEntriesRequest,
    endpoint: string,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await phytoviewService.get<PhytoViewEntryResponse>(
        `phytoview/v1/${endpoint}`,
        {
            params: data,
            ...authHeaders
        }
    );
    return response.data;
}
const getOnePhytoView = async (endpoint: string, id: number | null, accessToken: string) => {
    const response = await phytoviewService.get<PhytoviewEntry>(`phytoview/v1/${endpoint}/${id}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};
const createPhytoViewEntry = async (
    endpoint: string,
    payload: PhytoviewRequest,
    accessToken: string
) => {
    const response = await phytoviewService.post(`phytoview/v1/${endpoint}`, payload, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};
const editPhytoViewEntry = async (
    endpoint: string,
    id: number | null,
    payload: PhytoviewRequest,
    accessToken: string
) => {
    const payloadWithId = { ...payload, id: id };
    const response = await phytoviewService.patch(`phytoview/v1/${endpoint}`, payloadWithId, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};
export { getPhytoViewEntries, getOnePhytoView, createPhytoViewEntry, editPhytoViewEntry };
